export const UidMap = {
    usr: 'user',
    mkt: 'market',
    cat: 'category',
    prod: 'product',
    sku: 'sku',
    addr: 'address',
    so: 'order',
    mbr: 'member',
    org: 'org',
    att: 'attribute',
    attval: 'attribute_value',
    cart: 'cart',
    reg: 'registration',
    clm: 'warrant_claim'
} as const;

// export const UidTypeMap = {
//     user: 'usr',
//     market: 'mkt',
//     category: 'cat',
//     product: 'prod',
//     sku: 'sku',
//     address: 'addr',
//     order: 'so',
//     member: 'mbr',
//     org: 'org',
//     attribute: 'att',
//     attribute_value: 'attval',
//     cart: 'cart',
//     registration: 'reg',
//     warrant_claim: 'clm'
// } as const;
